import {Routes, Route} from "react-router-dom";
import VerifyAccount from "../VerifyAccount/VerifyAccount";
import LoginComponent from "./LoginComponent";
import {useAppContext} from "../../AppContext";
import ResetPasswordComponent from "../ResetPassword/ResetPasswordComponent";
import React, {useState} from "react";


export default function Login() {
  const {isLoading, setIsLoading} = useAppContext();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertStatus, setAlertStatus] = useState("error");

  const showAlert = (message, status = "error") => {
    setAlertMessage(message);
    setAlertStatus(status);
    setIsAlertVisible(true);
  }

  const hideAlert = () => setIsAlertVisible(false);

  return (<div className="App">
    <Routes>
      <Route path="/verify/:tokenId" element={<VerifyAccount/>}/>
      <Route path="/reset_password" element={<ResetPasswordComponent
        isAlertVisible={isAlertVisible}
        alertMessage={alertMessage}
        alertStatus={alertStatus}
        showAlert={showAlert}
        hideAlert={hideAlert}
      />}/>
      <Route
        path="*"
        element={<LoginComponent
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isAlertVisible={isAlertVisible}
          alertMessage={alertMessage}
          alertStatus={alertStatus}
          showAlert={showAlert}
          hideAlert={hideAlert}
        />}
      />
    </Routes>
  </div>);
}
